export const JUMPED_TO_PAGE = 'JUMPED_TO_PAGE'
export const BACK = 'BACK'
export const NEXT = 'NEXT'
export const CURRENT_PAGE_FETCHED = 'CURRENT_PAGE_FETCHED'
export const STEPS_FETCHED = 'STEPS_FETCHED'
export const STEP_COMPLETED = 'STEP_COMPLETED'
export const STEP_UNCOMPLETED = 'STEP_UNCOMPLETED'
export const LOAD_CLEAN_DATA = 'LOAD_CLEAN_DATA'
export const PATCH = 'PATCH'
